import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { CaseReassignmentBreadcrumbsHistory } from './functions';

const CaseReassignmentBreadcrumbs = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="case-reassignment-breadcrumbs"
      history={CaseReassignmentBreadcrumbsHistory(t, location)}
    />
  );
};

export default CaseReassignmentBreadcrumbs;
